import { observable, runInAction } from 'mobx';
import { CustomerUnidentifiedModel, ICustomerUnidentifiedServices } from 'services/Main/customerUnidentified_services';
import { DataResponse } from 'services/response';

export type CustomerUnidentifiedStore = {
  // Danh sách khách hàng chưa định danh
  listCustomerUnidentified: DataResponse<Array<CustomerUnidentifiedModel>>

  statusApi: DataResponse<any>
  // mảng id khách hàng chưa định danh
  // lưu id để xem chi tiết
  listIdCustomer: string[]


  createUpdate: DataResponse<any>

};

export interface ICustomerUnidentifiedPresenter {
  createStore(): CustomerUnidentifiedStore;
  //    Lấy danh sách khách hàng chưa định danh
  getlistCustomerUnidentified(store: CustomerUnidentifiedStore, data: object): Promise<void>
  //
  setListIdCustomer(store: CustomerUnidentifiedStore, listIdCustomer: string[]): Promise<void>
  // xóa khách hàng chưa định danh
  deleteCustomerUnidentified(store: CustomerUnidentifiedStore, data: object): Promise<void>
  // export
  exportData(data: object): Promise<void>
  // download template excel import khách hàng chưa định danh
  downloadTemplateExcel(): Promise<void>
  // import excel khách hàng chưa định danh
  importExcel(data: object): Promise<DataResponse<null> | null>

  // create
  createCampaignAnonymous(store: CustomerUnidentifiedStore, data: object): Promise<void>

}

export function createCustomerUnidentifiedPresenter({ customerUnidentifiedServices }: { customerUnidentifiedServices: ICustomerUnidentifiedServices }): ICustomerUnidentifiedPresenter {
  return {
    createStore: (): CustomerUnidentifiedStore =>
      observable({
        listCustomerUnidentified: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        createUpdate: {
          data: [],
          message: '',
          isSuccess: false,
        },
        statusApi: {
          data: [],
          message: '',
          isSuccess: false,
        },
        listIdCustomer: []
      }),
    //    Lấy danh sách khách hàng chưa định danh
    getlistCustomerUnidentified: async (store, dataSearch) => {
      try {
        const result = await customerUnidentifiedServices.getLisCustomerUnidentified(dataSearch);
        runInAction(() => {
          store.listCustomerUnidentified.data = result.data;
          store.listCustomerUnidentified.isSuccess = result.isSuccess;
          store.listCustomerUnidentified.message = result.message;
          store.listCustomerUnidentified.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    //  create
    createCampaignAnonymous: async (store, dataSearch) => {
      try {
        const result = await customerUnidentifiedServices.createCampaignAnonymous(dataSearch);
        runInAction(() => {
          store.createUpdate.isSuccess = result.isSuccess;
          store.createUpdate.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },


    // xóa khách hàng chưa định danh
    deleteCustomerUnidentified: async (store, data) => {
      try {
        const result = await customerUnidentifiedServices.deleteCustomerUnidentified(data);
        runInAction(() => {
          store.statusApi.isSuccess = result.isSuccess;
          store.statusApi.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // export report
    exportData: async (data) => {
      try {
        await customerUnidentifiedServices.exportData(data);

      } catch (error) {
        console.log(error);
      }
    },

    // download template excel import khách hàng chưa định danh
    downloadTemplateExcel: async () => {
      try {
        await customerUnidentifiedServices.downloadTemplateExcel();
      } catch (error) {
        console.log(error);
      }
    },
    // import excel khách hàng chưa định danh
    importExcel: async (data) => {
      try {
        const result = await customerUnidentifiedServices.importExcel(data);
        return result;
      } catch (error) {
        console.log(error);
        return null
      }
    },

    //
    setListIdCustomer: async (store, listIdCustomer) => {
      runInAction(() => {
        store.listIdCustomer = listIdCustomer;
      });

    },
  };
}
